import bootbox from "bootbox";

$(document).ready(function (e) {

    let $body = $('body');

    $body.on('click', '.edit-filter', function (e) {
        e.preventDefault();
        let table_id = $(this).attr('data-table-id'),
            filter_id = $(this).attr('data-id');

        window.location = `/filter/${table_id}/${filter_id}/edit`;
    });

    $body.on('click', '.add-criteria', function (e) {
        let table_id = $(this).data('table-id');

        $.ajax({
            type: 'GET',
            url: `/filter/${table_id}/row`,
            data: {
                queryBy: true
            },
            success: (res) => {
                let $criteria = $(this).parents('.criteria-group').find('.card-body');

                $criteria.append(res);
                $('.selectpicker').selectpicker({
                    noneSelectedText: translation.nothing_selected
                });

                let count = $(this).parents('.criteria-group').find('.single-criteria').length;

                if (count > 1) {
                    $(this).addClass('d-none');
                    $(this).siblings('.remove-criteria').removeClass('d-none');
                }
            }
        });
    });

    $body.on('click', '.add-group-criteria', function (e) {
        let table_id = $(this).data('table-id'),
            showGroupQuery = $('.criteria-group').length ? 1 : 0;

        $.ajax({
            type: 'GET',
            url: `/filter/${table_id}/group`,
            data: {
                showGroupQuery
            },
            success: (res) => {
                let $container = $('.criteria-group-container');

                $container.append(res);
                $('.selectpicker').selectpicker({
                    noneSelectedText: translation.nothing_selected
                });
            }
        });
    });

    $body.on('click', '.remove-criteria', function (e) {
        let $group = $(this).parents('.criteria-group'),
            count = $(this).parents('.criteria-group').find('.single-criteria').length,
            $prev = $(this).parents('.single-criteria').prev('.single-criteria');

        if (count > 1) {
            $(this).parents('.single-criteria').remove();
            $prev.find('.add-criteria').removeClass('d-none');
            count = count - 1;

            if (count === 1) {
                $group.find('.remove-criteria').addClass('d-none');
                $group.find('.add-criteria').removeClass('d-none');
            }
        }

        $group.find('.single-criteria').eq(0).find('.query-by-holder').remove();
    });

    $body.on('click', '.remove-criteria-group', function (e) {
        let $group = $(this).parents('.criteria-group'),
            count = $group.length;

        $group.remove();
        $('.criteria-group').eq(0).find('.query-by').remove();
    });

    $body.on('click', '.query-by', function (e) {
        let queryBy = $(this).attr('data-query-by'),
            or_translation = $(this).attr('data-or-translation'),
            and_translation = $(this).attr('data-and-translation');

        if (queryBy === 'AND') {
            $(this).attr('data-query-by', 'OR').text(or_translation);
        } else {
            $(this).attr('data-query-by', 'AND').text(and_translation);
        }
    });

    $body.on('changed.bs.select', 'select.criteria-field', function (e) {
        let value = $(this).find(':selected').val(),
            field_type = $(this).find(':selected').data('field-type'),
            type = $(this).find(':selected').data('type'),
            name = $(this).find(':selected').data('field-name'),
            $conditions = $(this).parents('.col-4').siblings('.condition-holder').find('.criteria-condition'),
            $criteria_value = $(this).parents('.col-4').siblings('.value-holder').find('.criteria-value'),
            $second_criteria_value = $(this).parents('.col-4').siblings('.value-holder').find('.second-criteria-value'),
            $duration_value = $(this).parents('.col-4').siblings('.value-holder').find('.duration-value'),
            $duration = $(this).parents('.col-4').siblings('.value-holder').find('.duration'),
            $criteria_value_holder = $(this).parents('.col-4').siblings('.value-holder'),
            numeric_fields = ['number', 'currency', 'decimal', 'formula'],
            date_fields = ['date', 'datetime'],
            numeric_conditions = ['=', '!=', '<', '<=', '>', '>=', 'between', 'not between', 'is empty', 'is not empty'],
            text_conditions = ['is', "isn't", 'contains', "doesn't contain", 'starts with', 'ends with', 'is empty', 'is not empty'],
            user_conditions = ['is', "isn't"],
            multi_user_conditions = ['is'],
            date_conditions = ['in the last', 'due in', 'on', 'before', 'between', 'Today', 'Yesterday', 'This Week', 'This Month', 'This Year', 'Last Week', 'Last Month', 'is empty', 'is not empty'],
            numeric_translations = JSON.parse($('.numeric-conditions').text().trim()),
            date_translations = JSON.parse($('.date-conditions').text().trim()),
            text_translations = JSON.parse($('.text-conditions').text().trim()),
            none_translation = $('.none').text().trim();

        if (value.length) {
            $conditions.empty();
            $conditions.append(`<option value="">${none_translation}</option>`);

            if (numeric_fields.includes(field_type)) {
                $(numeric_conditions).each((i, condition) => {
                    let $option = `<option value="${condition}">${numeric_translations[i]}</option>`
                    $conditions.append($option);
                    $conditions.prop('disabled', false);
                    $conditions.attr('data-type', 'number');
                });
            } else if (name === 'assigned_to' || name === 'multi_assigned_to' || name === 'created_by' || name === 'modified_by' || type === 'checkbox' || name === 'visibility') {
                $(user_conditions).each((i, condition) => {
                    let $option = `<option value="${condition}">${text_translations[i]}</option>`
                    $conditions.append($option);
                    $conditions.prop('disabled', false);
                    $conditions.attr('data-type', 'text');
                });
            } else if (date_fields.includes(type) || name === 'created_at' || name === 'updated_at') {
                $(date_conditions).each((i, condition) => {
                    let $option = `<option value="${condition}">${date_translations[i]}</option>`
                    $conditions.append($option);
                    $conditions.prop('disabled', false);
                    $conditions.attr('data-type', 'number');
                });
            } else {
                $(text_conditions).each((i, condition) => {
                    let $option = `<option value="${condition}">${text_translations[i]}</option>`;
                    $conditions.append($option);
                    $conditions.prop('disabled', false);
                    $conditions.attr('data-type', 'text');
                });
            }

            if (field_type === 'multiselect' || field_type === 'multipleselect' || type === 'radio' || type === 'select' || type === 'checkbox' || name === 'visibility') {
                if (name === 'visibility') {
                    $criteria_value_holder.empty();
                    $criteria_value_holder.append(
                        `<select class="form-control criteria-value" disabled>
                            <option value="0">Private</option>
                            <option value="1">Everyone</option>
                         </select>`
                    );
                } else if (type === 'checkbox') {
                    $criteria_value_holder.empty();
                    $criteria_value_holder.append(
                        `<select class="form-control criteria-value" disabled>
                            <option value="on">On</option>
                            <option value="off">Off</option>
                         </select>`
                    );
                } else {
                    let options = $(this).find(':selected').data('field-values');

                    $criteria_value_holder.empty();
                    $criteria_value_holder.append(`<select class="form-control criteria-value" disabled></select>`);

                    if (options.length) {
                        $(options).each(function (i, option) {
                            $criteria_value_holder.find('.criteria-value').append(`<option value="${option}">${option}</option>`);
                        });
                    }
                }
            } else if (name === 'assigned_to' || name === 'multi_assigned_to' || name === 'created_by' || name === 'modified_by') {
                let options = $(this).find(':selected').data('users');

                $criteria_value_holder.empty();
                let no_option = name !== 'multi_assigned_to' ? `<option value="">${none_translation}</option>` : '';
                $criteria_value_holder.append(
                    `<select class="form-control criteria-value ${name === 'multi_assigned_to' ? 'selectpicker' : ''}" ${name === 'multi_assigned_to' ? 'multiple' : ''} disabled >
                        ${no_option}
                    </select>`
                );

                if (options.length) {
                    $(options).each(function (i, option) {
                        $criteria_value_holder.find('.criteria-value').append(
                            `<option value="${option.id}">
                                ${option.first_name || option.last_name ? option.first_name + ' ' + option.last_name : 'Unnamed'}
                            </option>`
                        );
                    });

                    $criteria_value_holder.find('.selectpicker').selectpicker({
                        container: 'body',
                        noneSelectedText: translation.nothing_selected
                    });
                }
            } else {
                $criteria_value_holder.empty();
                $criteria_value_holder.append(`
                        <input type="text" class="form-control criteria-value" disabled>
                        <input type="text" class="form-control d-none second-criteria-value" disabled>
                        <input type="text" class="form-control duration-value d-none">
                        <select class="form-control duration d-none">
                            <option value="days">Days</option>
                            <option value="weeks">Weeks</option>
                            <option value="months">Months</option>
                        </select>
                `);
            }

            if (field_type === 'date' || name === 'created_at' || name === 'updated_at') {
                let date_format = $('meta[name="date-format"]').attr('content');

                $criteria_value = $(this).parents('.col-4').siblings('.value-holder').find('.criteria-value');
                $second_criteria_value = $(this).parents('.col-4').siblings('.value-holder').find('.second-criteria-value');
                $second_criteria_value = $(this).parents('.col-4').siblings('.value-holder').find('.second-criteria-value');
                if (type === 'date') {
                    $criteria_value.removeClass('datetimepicker-cl').addClass('datepicker-cl');
                    $second_criteria_value.removeClass('datetimepicker-cl').addClass('datepicker-cl');
                    $($criteria_value).flatpickr({
                        weekNumbers: true,
                        dateFormat: date_format
                    });
                    $($second_criteria_value).flatpickr({
                        dateFormat: date_format
                    });
                }

                if (type === 'datetime' || name === 'created_at' || name === 'updated_at') {
                    $criteria_value.removeClass('datepicker-cl').addClass('datetimepicker-cl');
                    $second_criteria_value.removeClass('datepicker-cl').addClass('datetimepicker-cl');

                    $($criteria_value).flatpickr({
                        weekNumbers: true,
                        dateFormat: date_format + " H:i",
                        enableTime: true
                    });
                    $($second_criteria_value).flatpickr({
                        weekNumbers: true,
                        dateFormat: date_format + " H:i",
                        enableTime: true
                    });
                }
            } else {
                if ($criteria_value.hasClass('flatpickr-input')) {
                    $($criteria_value).flatpickr().destroy();
                    $($second_criteria_value).flatpickr().destroy();
                }
            }
        } else {
            $conditions.empty();
            $conditions.prop('disabled', true);
            $criteria_value.val('').prop('disabled', true);
            $second_criteria_value.val('').prop('disabled', true).addClass('d-none');
            $duration_value.addClass('d-none');
            $duration.addClass('d-none');
        }
    });

    $body.on('change', '.criteria-condition', function (e) {
        let value = $(this).find(':selected').val(),
            $val_holder = $(this).parents('.col-4').siblings('.value-holder').find('.criteria-value'),
            $second_val_holder = $(this).parents('.col-4').siblings('.value-holder').find('.second-criteria-value'),
            $duration_value = $(this).parents('.col-4').siblings('.value-holder').find('.duration-value'),
            $duration = $(this).parents('.col-4').siblings('.value-holder').find('.duration'),
            $field_holder = $(this).parents('.col-4').siblings('.criteria-field-holder').find('.criteria-field'),
            name = $($field_holder).find(':selected').data('field-name'),
            field_type = $($field_holder).find(':selected').data('field-type'),
            type = $($field_holder).find(':selected').data('type');

        if (value.length) {
            if (field_type === 'date' || name === 'created_at' || name === 'updated_at') {
                $val_holder.addClass('d-none');
                $second_val_holder.addClass('d-none');
                $val_holder.prop('disabled', true);
                $second_val_holder.prop('disabled', true);

                if (value === 'in the last' || value === 'due in') {
                    $duration_value.removeClass('d-none');
                    $duration.removeClass('d-none');
                } else if (value === 'on' || value === 'before') {
                    $duration_value.addClass('d-none');
                    $duration.addClass('d-none');
                    $val_holder.removeClass('d-none');
                    $val_holder.prop('disabled', false);
                } else if (value === 'between') {
                    $duration_value.addClass('d-none');
                    $duration.addClass('d-none');

                    $val_holder.removeClass('d-none');
                    $second_val_holder.removeClass('d-none');

                    $val_holder.prop('disabled', false);
                    $second_val_holder.prop('disabled', false);
                } else if (
                    value === 'Today' ||
                    value === 'Yesterday' ||
                    value === 'This Week' ||
                    value === 'This Month' ||
                    value === 'This Year' ||
                    value === 'Last Week' ||
                    value === 'Last Month' ||
                    value === 'is empty' ||
                    value === 'is not empty'
                ) {
                    $duration_value.addClass('d-none');
                    $duration.addClass('d-none');
                    $val_holder.removeClass('d-none').val('');
                    $val_holder.prop('disabled', true);

                }
            } else {
                if (value !== 'is empty' && value !== 'is not empty') {
                    $val_holder.prop('disabled', false);
                    $second_val_holder.prop('disabled', false);
                } else {
                    $val_holder.val('').prop('disabled', true);
                    $second_val_holder.val('').prop('disabled', true);
                }

                if (value === 'between' || value === 'not between') {
                    $val_holder.attr('placeholder', 'integer,integer');
                    $second_val_holder.attr('placeholder', 'integer,integer');
                } else {
                    $val_holder.attr('placeholder', '');
                    $second_val_holder.attr('placeholder', '');
                }

                if ($val_holder.hasClass('selectpicker')) {
                    $val_holder.selectpicker('refresh');
                }
            }

        } else {
            $val_holder.val('').prop('disabled', true).removeClass('d-none');
            $second_val_holder.val('').prop('disabled', true).addClass('d-none');
            $duration_value.addClass('d-none');
            $duration.addClass('d-none');
        }
    });

    $body.on('click', '.add-to-available', function (e) {
        e.preventDefault();
        let $column = $(this),
            $selected_columns = $('.selected-columns'),
            field_name = $($column).attr('data-field-name');

        // Requested to display all fields by default in task:
        // https://app.asana.com/0/1129237646310738/1170137950937865/f
        // $('.sort-field[data-field-name="' + field_name + '"]').removeClass('d-none');

        $($column)
            .appendTo($selected_columns)
            .removeClass('add-to-available')
            .addClass('remove-from-selected')
            .find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
    });

    $body.on('click', '.remove-from-selected', function (e) {
        e.preventDefault();
        let $column = $(this),
            $selected_columns = $('.available-columns'),
            field_name = $($column).attr('data-field-name'),
            $sorting_dropdown = $('.sorting-dropdown'),
            selected_sort = $($sorting_dropdown).attr('data-sort-field');

        // Requested to display all fields by default in task:
        // https://app.asana.com/0/1129237646310738/1170137950937865/f

        // if (selected_sort === field_name) {
        //     $($sorting_dropdown).attr('data-sort-field', '').attr('data-sort-order', '');
        //     $($sorting_dropdown).find('.ascending.active, .descending.active').removeClass('active').parents('.collapse').removeClass('show');
        // }
        //
        // $('.sort-field[data-field-name="' + field_name + '"]').addClass('d-none');

        $($column)
            .appendTo($selected_columns)
            .removeClass('remove-from-selected')
            .addClass('add-to-available')
            .find('.fa-minus').removeClass('fa-minus').addClass('fa-plus');
    });

    $(".selected-columns").sortable({cursor: 'grab'});

    $body.on('click', '.save-filter', function (e) {
        let table_id = $(this).data('table-id'),
            $criterias = $('.single-criteria'),
            $group_criterias = $('.criteria-group'),
            error = false,
            group_payload = [],
            columns = [],
            filter_title = $('#filter-title').val(),
            filter_type = $('#filter-type').val(),
            $selected_columns = $('.selected-columns').find('.column'),
            visibility = $('#filter-privacy').is(':checked') ? '0' : '1',
            filter_groups = $('#filter-groups').val(),
            filter_users = $('#filter-users').val(),
            default_users = $('#default-users').val(),
            sorting_field = $('.sorting-dropdown').attr('data-sort-field'),
            sorting_order = $('.sorting-dropdown').attr('data-sort-order'),
            default_field_order = $('.default-field-order').is(':checked') ? 1 : 0,
            redirect = $(this).attr('data-redirect');

        $group_criterias.each((group_order, $group) => {
            let $criterias = $($group).find('.single-criteria'),
                $queryBy = $($group).find('.group-query-by'),
                groupQueryBy = '',
                payload = [];

            if ($queryBy.length && group_order !== 0) {
                if ($queryBy.attr('data-query-by') === 'AND') {
                    groupQueryBy = 'where';
                } else {
                    groupQueryBy = 'orWhere';
                }
            } else {
                groupQueryBy = 'where';
            }

            $criterias.each((i, $criteria) => {
                let field = $($criteria).find('.criteria-field').find(':selected').val(),
                    field_name = $($criteria).find('.criteria-field').find(':selected').attr('data-field-name'),
                    condition = $($criteria).find('.criteria-condition').find(':selected').val(),
                    type = $($criteria).find('.criteria-field').find(':selected').attr('data-type'),
                    field_type = $($criteria).find('.criteria-field').find(':selected').attr('data-field-type'),
                    value = $($criteria).find('.criteria-value').val(),
                    second_value = $($criteria).find('.second-criteria-value').val(),
                    duration = $($criteria).find('.duration').val(),
                    duration_value = $($criteria).find('.duration-value').val(),
                    $queryBy = $($criteria).find('.query-by'),
                    queryBy = '';

                if (field_name === 'multi_assigned_to') {
                    value = $($criteria).find('.criteria-value.selectpicker').val();
                    if (value.length) {
                        value = JSON.stringify(value);
                    }
                }

                if (field_type === 'number') {
                    if (decimal_separator !== '.') {
                        value = value.split(',').join('.');
                    }
                }

                if ($queryBy.length) {
                    if ($queryBy.attr('data-query-by') === 'AND') {
                        queryBy = 'where';
                    } else {
                        queryBy = 'orWhere';
                    }
                } else {
                    queryBy = 'where';
                }

                if (field.length || condition.length || value.length) {
                    if (!field.length) {
                        alert('Please select a field');
                        error = true;
                        return;
                    }
                    if (!condition.length) {
                        alert('Please select a valid condition');
                        error = true;
                        return;
                    }

                    if (field_type === 'date' || field_name === 'created_at' || field_name === 'updated_at') {
                        if (condition === 'in the last' || condition === 'due in') {
                            if (!duration.length || !duration_value.length) {
                                alert('Please specify duration');
                                error = true;
                            } else {
                                value = JSON.stringify({
                                    'duration': duration,
                                    'duration_value': duration_value
                                });
                            }
                        }
                        if (condition === 'between') {
                            if (!value.length || !second_value.length) {
                                alert('Please specify before and after duration');
                                error = true;
                            } else {
                                value = JSON.stringify({
                                    'after': value,
                                    'before': second_value
                                });
                            }
                        }

                        if (condition === 'on' || condition === 'before') {
                            if (!value.length) {
                                alert('Please specify a valid date');
                                error = true;
                            }
                        }
                    } else {
                        if ((condition !== 'is empty' && condition !== 'is not empty') && !value.length) {
                            alert('Please specify a valid value');
                            error = true;
                            return;
                        }
                    }
                    payload.push([field, type, condition, value, queryBy]);
                }
            });

            group_payload.push({
                groupQueryBy,
                group_order,
                payload
            });
        });

        console.log(group_payload);

        $selected_columns.each((i, $column) => {
            columns.push($($column).data('field-id'));
        });

        if (!filter_title.length) {
            alert('Please enter filter name');
            return;
        }

        if (!default_field_order && !$selected_columns.length) {
            alert('Select columns for filter');
            return;
        }

        if (!error) {
            $.ajax({
                method: 'POST',
                url: `/filter/${table_id}`,
                data: {
                    group_payload: group_payload,
                    title: filter_title,
                    columns: columns,
                    visibility: visibility,
                    sorting_field: sorting_field,
                    sorting_order: sorting_order,
                    default_field_order: default_field_order,
                    filter_type: filter_type === 'xml' ? 1 : 0,
                    filter_users,
                    filter_groups,
                    default_users,
                },
                success: function (res) {
                    if (res.created) {
                        if (filter_type === 'xml') {
                            window.location = `/settings/xml_builder`;
                        } else {

                            if(redirect === 'calendar'){
                                window.location = `/browse/${table_id}/calendar?filter=${res.id}`;
                            }else{
                                window.location = `/browse/${table_id}?filter=${res.id}`;
                            }
                        }
                    }
                }
            })
        }
    });

    $body.on('click', '.update-filter', function (e) {
        let table_id = $(this).data('table-id'),
            filter_id = $(this).data('filter-id'),
            $criterias = $('.single-criteria'),
            $group_criterias = $('.criteria-group'),
            error = false,
            group_payload = [],
            columns = [],
            filter_title = $('#filter-title').val(),
            filter_type = $('#filter-type').val(),
            $selected_columns = $('.selected-columns').find('.column'),
            visibility = $('#filter-privacy').is(':checked') ? '0' : '1',
            filter_groups = $('#filter-groups').val(),
            filter_users = $('#filter-users').val(),
            default_users = $('#default-users').val(),
            sorting_field = $('.sorting-dropdown').attr('data-sort-field'),
            sorting_order = $('.sorting-dropdown').attr('data-sort-order'),
            default_field_order = $('.default-field-order').is(':checked') ? 1 : 0,
            redirect = $(this).attr('data-redirect');

        $group_criterias.each((group_order, $group) => {

            let $criterias = $($group).find('.single-criteria'),
                $queryBy = $($group).find('.group-query-by'),
                groupQueryBy = '',
                payload = [];

            if ($queryBy.length && group_order !== 0) {
                if ($queryBy.attr('data-query-by') === 'AND') {
                    groupQueryBy = 'where';
                } else {
                    groupQueryBy = 'orWhere';
                }
            } else {
                groupQueryBy = 'where';
            }

            $criterias.each((i, $criteria) => {
                let field = $($criteria).find('.criteria-field').find(':selected').val(),
                    field_name = $($criteria).find('.criteria-field').find(':selected').attr('data-field-name'),
                    condition = $($criteria).find('.criteria-condition').find(':selected').val(),
                    type = $($criteria).find('.criteria-field').find(':selected').attr('data-type'),
                    field_type = $($criteria).find('.criteria-field').find(':selected').attr('data-field-type'),
                    value = $($criteria).find('.criteria-value').val(),
                    second_value = $($criteria).find('.second-criteria-value').val(),
                    duration = $($criteria).find('.duration').val(),
                    duration_value = $($criteria).find('.duration-value').val(),
                    $queryBy = $($criteria).find('.query-by'),
                    queryBy = '';

                if (field_name === 'multi_assigned_to') {
                    value = $($criteria).find('.criteria-value.selectpicker').val();
                    if (value.length) {
                        value = JSON.stringify(value);
                    }
                }

                if (field_type === 'number') {
                    if (decimal_separator !== '.') {
                        value = value.split(',').join('.');
                    }
                }

                if ($queryBy.length) {
                    if ($queryBy.attr('data-query-by') === 'AND') {
                        queryBy = 'where';
                    } else {
                        queryBy = 'orWhere';
                    }
                } else {
                    queryBy = 'where';
                }

                if (field.length || condition.length || value.length) {
                    if (!field.length) {
                        alert('Please select a field');
                        error = true;
                        return;
                    }
                    if (!condition.length) {
                        alert('Please select a valid condition');
                        error = true;
                        return;
                    }

                    if (field_type === 'date' || field_name === 'created_at' || field_name === 'updated_at') {
                        if (condition === 'in the last' || condition === 'due in') {
                            if (!duration.length || !duration_value.length) {
                                alert('Please specify duration');
                                error = true;
                            } else {
                                value = JSON.stringify({
                                    'duration': duration,
                                    'duration_value': duration_value
                                });
                            }
                        }
                        if (condition === 'between') {
                            if (!value.length || !second_value.length) {
                                alert('Please specify before and after duration');
                                error = true;
                            } else {
                                value = JSON.stringify({
                                    'after': value,
                                    'before': second_value
                                });
                            }
                        }

                        if (condition === 'on' || condition === 'before') {
                            if (!value.length) {
                                alert('Please specify a valid date');
                                error = true;
                            }
                        }
                    } else {
                        if ((condition !== 'is empty' && condition !== 'is not empty') && !value.length) {
                            alert('Please specify a valid value');
                            error = true;
                            return;
                        }
                    }

                    payload.push([field, type, condition, value, queryBy]);
                }
            });

            group_payload.push({
                groupQueryBy,
                group_order,
                payload
            });
        });

        console.log(group_payload);

        $selected_columns.each((i, $column) => {
            columns.push($($column).data('field-id'));
        });

        if (!filter_title.length) {
            alert('Please enter filter name');
            return;
        }

        if (!default_field_order && !$selected_columns.length) {
            alert('Select columns for filter');
            return;
        }

        if (!error) {
            $.ajax({
                method: 'POST',
                url: `/filter/${table_id}/${filter_id}/update`,
                data: {
                    group_payload: group_payload,
                    columns: columns,
                    title: filter_title,
                    visibility: visibility,
                    sorting_field: sorting_field,
                    sorting_order: sorting_order,
                    default_field_order: default_field_order,
                    filter_type: filter_type === 'xml' ? 1 : 0,
                    filter_users,
                    filter_groups,
                    default_users
                },
                success: function (res) {
                    if (res) {
                        if (filter_type === 'xml') {
                            window.location = '/settings/xml_builder';
                        } else {
                            if(redirect === 'calendar'){
                                window.location = `/browse/${table_id}/calendar?filter=${filter_id}`;
                            }else{
                                window.location = `/browse/${table_id}?filter=${filter_id}`;
                            }
                        }
                    }
                }
            })
        }
    });

    $body.on('click', '.cancel-filter-save', function (e) {
        let table_id = $(this).data('table-id'),
            filter_type = $('#filter-type').val(),
            redirect = $(this).attr('data-redirect'),
            filter_id = $(this).attr('data-filter-id')

        if (filter_type === 'xml') {
            window.location = '/settings/xml_builder';
        } else {
            if(redirect === 'calendar'){
                window.location = `/browse/${table_id}/calendar?filter=${filter_id}`;
            }else{
                window.location = `/browse/${table_id}?filter=${filter_id}`;
            }
        }
    });

    $body.on('click', '.tick-criteria', function (e) {
        let $checkbox = $(this),
            $criteria = $(this).siblings('.criteria'),
            $filter_action = $('.filter-action');

        if ($checkbox.is(':checked')) {
            $criteria.removeClass('d-none');
        } else {
            $criteria.addClass('d-none');
        }

        let count = $('.tick-criteria:checked').length;

        if (count) {
            $filter_action.removeClass('d-none');
        } else {
            $filter_action.addClass('d-none');
        }
    });

    $body.on('change', '.sidebar-condition', function (e) {
        let value = $(this).find(':selected').val(),
            $field = $(this).parents('.criteria').siblings('.tick-criteria'),
            name = $($field).attr('data-field-name'),
            type = $($field).attr('data-type'),
            field_type = $($field).attr('data-field-type');

        if (field_type === 'date' || name === 'created_at' || name === 'updated_at') {
            let $from_val = $(this).siblings('.condition-value.from-date'),
                $to_val = $(this).siblings('.condition-value.to-date'),
                $duration_value = $(this).siblings('.duration-value'),
                $duration = $(this).siblings('.duration');

            if (value.length) {
                if (value === 'in the last' || value === 'due in') {
                    $duration_value.removeClass('d-none');
                    $duration.removeClass('d-none');
                    $from_val.addClass('d-none');
                    $to_val.addClass('d-none');
                } else if (value === 'on' || value === 'before') {
                    $duration_value.addClass('d-none');
                    $duration.addClass('d-none');
                    $from_val.removeClass('d-none');
                    $to_val.addClass('d-none');
                } else if (value === 'between') {
                    $duration_value.addClass('d-none');
                    $duration.addClass('d-none');
                    $from_val.removeClass('d-none');
                    $to_val.removeClass('d-none');
                } else if (
                    value === 'Today' ||
                    value === 'Yesterday' ||
                    value === 'This Week' ||
                    value === 'This Month' ||
                    value === 'This Year' ||
                    value === 'Last Week' ||
                    value === 'Last Month' ||
                    value === 'is empty' ||
                    value === 'is not empty'
                ) {
                    $duration_value.addClass('d-none');
                    $duration.addClass('d-none');
                    $from_val.addClass('d-none');
                    $to_val.addClass('d-none');
                }
            }
        } else {
            let $val_holder = $(this).siblings('.condition-value');
            if (value.length) {
                if (value !== 'is empty' && value !== 'is not empty') {
                    $val_holder.prop('disabled', false);
                } else {
                    $val_holder.prop('disabled', true);
                }

                if (value === 'between' || value === 'not between') {
                    $val_holder.attr('placeholder', 'integer,integer');
                } else {
                    $val_holder.attr('placeholder', '');
                }

            } else {
                $val_holder.val('').prop('disabled', true);
            }
        }
    });

    $body.on('click', '.apply-filter', function (e) {
        let $criterias = $('.filter-field'),
            error = false,
            payload = [];

        $criterias.each((i, $criteria) => {
            if ($($criteria).find('.tick-criteria').is(':checked')) {

                let field = $($criteria).find('.tick-criteria').val(),
                    condition = $($criteria).find('.sidebar-condition').find(':selected').val(),
                    type = $($criteria).find('.tick-criteria').attr('data-type'),
                    name = $($criteria).find('.tick-criteria').attr('data-field-name'),
                    field_type = $($criteria).find('.tick-criteria').attr('data-field-type'),
                    value = $($criteria).find('.condition-value').val();

                if (name === 'multi_assigned_to') {
                    value = $($criteria).find('.selectpicker').val();
                }

                if (!field.length) {
                    alert('Please select a field');
                    error = true;
                    return;
                }
                if (!condition.length) {
                    alert('Please select a valid condition for ' + field);
                    error = true;
                    return;
                }

                console.log(field, type, condition, value);

                if (type === 'date' || type === 'datetime' || name === 'created_at' || name === 'updated_at') {

                    let from_val = $($criteria).find('.condition-value.from-date').val(),
                        to_val = $($criteria).find('.condition-value.to-date').val(),
                        duration_value = $($criteria).find('.duration-value').val(),
                        duration = $($criteria).find('.duration').val();

                    console.log(from_val, to_val, duration_value, duration);

                    if (condition === 'in the last' || condition === 'due in') {

                        if (!duration_value.length) {
                            alert('Please select duration value for ' + field);
                            error = true;
                            return;
                        }

                        if (!duration.length) {
                            alert('Please select duration for ' + field);
                            error = true;
                            return;
                        }

                        payload.push([field, condition, {duration_value, duration}]);

                    } else if (condition === 'on' || condition === 'before') {

                        if (!from_val.length) {
                            alert('Please select duration value for ' + field);
                            error = true;
                            return;
                        }

                        payload.push([field, condition, from_val]);

                    } else if (condition === 'between') {

                        if (!from_val.length) {
                            alert('Please specify from range value for ' + field);
                            error = true;
                            return;
                        }

                        if (!to_val.length) {
                            alert('Please specify to range value for ' + field);
                            error = true;
                            return;
                        }

                        payload.push([field, condition, {from_val, to_val}]);

                    } else if (
                        condition === 'Today' ||
                        condition === 'Yesterday' ||
                        condition === 'This Week' ||
                        condition === 'This Month' ||
                        condition === 'This Year' ||
                        condition === 'Last Week' ||
                        condition === 'Last Month' ||
                        condition === 'is empty' ||
                        condition === 'is not empty'
                    ) {
                        payload.push([field, condition, '']);
                    }

                } else {
                    if ((condition !== 'is empty' && condition !== 'is not empty') && !value.length) {
                        alert('Please specify a valid value for ' + field);
                        error = true;
                        return;
                    }

                    payload.push([field, condition, value]);
                }
            }
        });

        if (!error) {
            window.location = window.location.href.split('?')[0] + `?filterBy=${JSON.stringify(payload)}`
        }
    });

    $body.on('click', '.show-filters', function (e) {
        e.preventDefault();
        $('.filter-sidebar').removeClass('d-none');
        $('.body-wrapper').addClass('expanded');
    });

    $body.on('click', '.close-filters', function (e) {
        e.preventDefault();
        $('.filter-sidebar').addClass('d-none');
        $('.page-container').removeClass('filter-opened');
        if (!$('#sidebar').hasClass('expanded')) {
            $('.body-wrapper').removeClass('expanded');
        }
    });

    $body.on('click', '.cancel-filter', function (e) {
        e.preventDefault();
        window.location = window.location.href.split('?')[0];
    });

    $body.on('click', '.delete-filter', function (e) {
        e.preventDefault();
        let id = $(this).data('id'),
            message = $(this).data('message'),
            table_id = $(this).data('table-id'),
            is_xml = $(this).data('is-xml-filter');

        bootbox.confirm(message, function (result) {
            if (result) {
                $.ajax({
                    type: 'DELETE',
                    url: `/filter/${id}`,
                    success: function (res) {
                        if (res) {
                            if (is_xml) {
                                window.location = '/settings/xml_builder';
                            } else {
                                window.location = `/browse/${table_id}`;
                            }
                        }
                    }
                })
            }
        })
    });

    $body.on('change', '.default-field-order', function (e) {
        if ($(this).is(':checked')) {
            $('.columns-holder').addClass('d-none');
        } else {
            $('.columns-holder').removeClass('d-none');
        }
    });

    $("#filter-privacy").on('change', function (e) {
        if ($(this).is(':checked')) {
            $('.filter-user-groups').removeClass('d-none');
        } else {
            $('.filter-user-groups').addClass('d-none');
        }
    });

    $('.mark-filter-default').on('click', function (e) {
        let table_id = $(this).attr('data-table-id'),
            filter_id = $(this).attr('data-filter-id'),
            has_default = parseInt($(this).attr('data-has-default')),
            default_name = $(this).attr('data-default-name');

        if (has_default) {
            bootbox.confirm('Default filter already exist (' + default_name + '). Do you want to change it?', function (result) {
                if (result) {
                    markFilterAsDefault(table_id, filter_id)
                }
            })
        } else {
            markFilterAsDefault(table_id, filter_id)
        }
    });

    function markFilterAsDefault(table_id, filter_id) {
        $.ajax({
            type: "POST",
            url: "/filter/mark_as_default",
            data: {
                filter_id,
                table_id
            },
            success: function (res) {
                $('.remove-filter-default').addClass('d-inline-block').removeClass('d-none');
                $('.mark-filter-default').removeClass('d-inline-block').addClass('d-none');
            }
        })
    }

    $('.remove-filter-default').on('click', function (e) {
        e.preventDefault();
        let table_id = $(this).attr('data-table-id'),
            filter_id = $(this).attr('data-filter-id');

        $.ajax({
            type: "DELETE",
            url: "/filter/mark_as_default",
            data: {
                filter_id,
                table_id
            },
            success: function (res) {
                if (res) {
                    $('.remove-filter-default').removeClass('d-inline-block').addClass('d-none');
                    $('.mark-filter-default').addClass('d-inline-block').removeClass('d-none');
                }
            }
        });
    });
});